import { render, staticRenderFns } from "./chargeList.vue?vue&type=template&id=28228202&scoped=true&"
import script from "./chargeList.vue?vue&type=script&lang=js&"
export * from "./chargeList.vue?vue&type=script&lang=js&"
import style0 from "./chargeList.vue?vue&type=style&index=0&id=28228202&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28228202",
  null
  
)

export default component.exports